import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/tooth-background.png'
import _imports_1 from '@/assets/img/dentist.png'


const _withScopeId = n => (_pushScopeId("data-v-57ff67fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "background-img",
    src: _imports_0,
    alt: "Welcome-to-proximal"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "dentist-img",
    src: _imports_1,
    alt: "Welcome-to-proximal-banner"
  })
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-info" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Welcome to Proximal"),
  /*#__PURE__*/_createElementVNode("p", { class: "intro" }, [
    /*#__PURE__*/_createTextVNode("Know your patient and "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" provide care with confidence")
  ])
], -1))

import {onMounted, watch} from 'vue' 
import {useRouter} from 'vue-router'
import { useMsal } from '@/msal/useMsal'
import { useIsAuthenticated } from '@/msal/useIsAuthenticated'
import { loginRequest } from '@/authConfig'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const { instance, accounts } = useMsal()
const isAuthenticated = useIsAuthenticated()
 
watch(isAuthenticated, async () => {
    if (isAuthenticated.value) {
        // check if user logged first time, and get them to read legal/email notifications
        const idTokenClaims: any = accounts.value[0].idTokenClaims
        console.log(idTokenClaims)
        if (idTokenClaims?.newUser) {
            router.push('/SignUp')
        } else {
            router.push('/Conditions')
        }
    }    
})
const signInRedirect = () => {
    instance.loginRedirect(loginRequest)
}
onMounted(() => 
{
    if (isAuthenticated.value) {
     router.push('/Conditions')
    }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("main", { class: "content" }, [
      _hoisted_2,
      _createElementVNode("div", { class: "bottom-nav" }, [
        _createElementVNode("button", { onClick: signInRedirect }, "GET STARTED")
      ])
    ])
  ], 64))
}
}

})